import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-right.svg';
import Button from 'components/Button/Button';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import StepItem from 'components/StepItem/StepItem';
import TitleTableWrapper from 'components/TitleTableWrapper/TitleTableWrapper';
import TitleWrapper from 'components/TitleWrapper/TitleWrapper';
import { TASK_HEAD_BOARD_CELLS } from 'constants/dataSets';
import { BUTTON_VARIANT } from 'constants/interfaces';

import CreateBoard from './components/CreateBoard/CreateBoard';
import ItemsTable from './components/ItemsTable/ItemsTable';

import type IMaterialityAssessmentBoard from './interfaces/IMaterialityAssessmentBoard';

import styles from './scss/MaterialityAssessmentBoard.module.scss';

function MaterialityAssessmentBoardView({
  isEmptyList, loading, addStakeholder, goBack, goToNextMaterialityAssessment, openModal,
  boards, onEditRecord, onLoadMore, hasMore, isLoadingMore, onDeleteItem,
  selectedItem, recordId, setBoards, currentId, setOpenModal, vcmName, vcmId,
  isViewOnly = false,
}: IMaterialityAssessmentBoard) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <span className={styles.header}>{t('materialityAssessment.titleStakeholder', { vcmName })}</span>
      <div className={styles.rootContainer}>
        <div className={styles.wrapper}>
          <TitleWrapper
            description={t('materialityAssessment.titleStakeholderDescription')}
          />

          <div className={styles.stepStakeholder}>
            <StepItem title={t('materialityAssessment.titleStepStakeholder')} step={1} done />
            <ArrowRightIcon />
            <StepItem title={t('materialityAssessment.titleSecondStepStakeholder')} step={2} />
          </div>

          <TitleTableWrapper
            title={t('materialityAssessment.importantBoards')}
            buttonTitle={t('materialityAssessment.addBoard')}
            onButtonClick={addStakeholder}
            buttonClassName={styles.button}
            showButton={!isEmptyList && !isViewOnly}
          />
          <div className={styles.contentWrapper}>
            {isEmptyList && !loading ? (
              <EmptyTaskManagement
                title={t('materialityAssessment.emptyBoardDescription')}
                buttonTitle={t('materialityAssessment.addStakeholder')}
                buttonOnClick={addStakeholder}
                disabledButton={isViewOnly}
              />
            ) : (
              <div className={styles.tableWrapper}>
                {boards.length > 0 && (
                  <ItemsTable
                    items={boards}
                    headCells={TASK_HEAD_BOARD_CELLS}
                    onEditRecord={onEditRecord}
                    onLoadMore={onLoadMore}
                    hasMore={hasMore}
                    isLoadingMore={isLoadingMore}
                    onDeleteItem={onDeleteItem}
                    isInfoTable
                    isViewOnly={isViewOnly}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={goBack}
          />
          <Button
            title={t('common.next')}
            onClick={goToNextMaterialityAssessment}
            className={styles.button}
          />
        </div>
      </div>
      <CreateBoard
        open={openModal}
        onClose={addStakeholder}
        title={t('materialityAssessment.addAnBoardMember')}
        selectedItem={selectedItem}
        recordId={recordId}
        setBoards={setBoards}
        currentId={currentId}
        setOpenModal={setOpenModal}
        vcmId={vcmId}
      />
    </div>
  );
}

export default MaterialityAssessmentBoardView;
